import { render, staticRenderFns } from "./LawyerAdd.vue?vue&type=template&id=de5cdb10&scoped=true"
import script from "./LawyerAdd.vue?vue&type=script&lang=js"
export * from "./LawyerAdd.vue?vue&type=script&lang=js"
import style0 from "./LawyerAdd.vue?vue&type=style&index=0&id=de5cdb10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5cdb10",
  null
  
)

export default component.exports